import { render, staticRenderFns } from "./WorkOrderKpiModuleContent.vue?vue&type=template&id=1d0628a6&scoped=true"
import script from "./WorkOrderKpiModuleContent.vue?vue&type=script&lang=js"
export * from "./WorkOrderKpiModuleContent.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderKpiModuleContent.vue?vue&type=style&index=0&id=1d0628a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0628a6",
  null
  
)

export default component.exports